module.exports = __webpack_public_path__ + "static/media/Fabian.be512fdf.jpg";